import React, { useState, useRef, useEffect } from 'react';
import { Flex, Box, AspectRatio, ModalBody } from '@stockx/ui';
import UserGeneratedContentModalContent from '../UserGeneratedContentModalContent';
import UserGeneratedContentImageLabel from '../UserGeneratedContentImageLabel';
import UserGeneratedContentCreatorHeader from '../UserGeneratedContentCreatorHeader';
import UserGeneratedContentModalImage from '../UserGeneratedContentModalImage';

const UserGeneratedContentModalDesktop = ({ styles, entry }) => {
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHeight(ref.current?.clientHeight || 0);
  }, []);

  return (
    <Flex p="0" h="100%">
      <Box position="relative" w={{ md: '57%' }} ref={ref} height="100%">
        <UserGeneratedContentImageLabel creator={entry?.creator} />
        <AspectRatio maxW="647px" ratio={1}>
          <UserGeneratedContentModalImage imageUrl={entry?.image?.url} />
        </AspectRatio>
      </Box>
      <ModalBody sx={styles.body} w={{ md: '50%' }} height="inherit">
        <Box mt={4} ml={1} mr={1} maxW="97%">
          <UserGeneratedContentCreatorHeader
            creator={entry?.creator}
            creatorProfilePhoto={entry?.creatorProfilePhoto}
          />
          <UserGeneratedContentModalContent
            leftContainerHeight={height}
            entry={entry}
          />
        </Box>
      </ModalBody>
    </Flex>
  );
};

export default UserGeneratedContentModalDesktop;
